module.exports = __webpack_public_path__ + "static/media/product-request.8efb9db4.svg";